import React from 'react';
import { styled } from '@mui/material/styles';
import { Warning, CheckCircle, Error } from '@mui/icons-material';
import { Typography, Box } from '@mui/material';

const StyledBox = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'status'
})(({ theme, status }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(2),
	borderRadius: theme.shape.borderRadius,
	marginBottom: theme.spacing(2),
	backgroundColor:
		status === 'success'
			? theme.palette.success.light
			: status === 'warning'
				? theme.palette.warning.light
				: theme.palette.error.light,
	color:
		status === 'success'
			? theme.palette.success.main
			: status === 'warning'
				? theme.palette.warning.main
				: theme.palette.error.main
}));

const StyledIcon = styled('div')(({ theme }) => ({
	marginRight: theme.spacing(1)
}));

const StatusMessage = ({ status, message }) => {
	let icon;

	switch (status) {
		case 'success':
			icon = <CheckCircle />;
			break;
		case 'warning':
			icon = <Warning />;
			break;
		case 'danger':
			icon = <Error />;
			break;
		default:
			icon = null;
	}

	return (
		<StyledBox status={status}>
			{icon && <StyledIcon>{icon}</StyledIcon>}
			<Typography variant="body1">{message}</Typography>
		</StyledBox>
	);
};

export default StatusMessage;
